module.exports = {
      id: "thankyou-usage",
      viewBox: "0 0 75 75",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#thankyou-usage",
      toString: function () {
        return this.url;
      }
    }